export const constants = {
  MEDMAIN_ACCOUNTS_WEBSITE_URL: process.env.REACT_APP_MEDMAIN_ACCOUNTS_WEBSITE_URL,
  MEDMAIN_IMAGES_URL: process.env.REACT_APP_MEDMAIN_IMAGES_URL,
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL
};
